// extracted by mini-css-extract-plugin
export default {"scrollBar":"offer-form_scrollBar__qSYdu","textAreaScroll":"offer-form_textAreaScroll__bxcS0","list":"offer-form_list__aXhqI offer-form_scrollBar__qSYdu"};